import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import Avatar from "Components/common/Avatar/Avatar";

@connect( store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser
    }
})

class Member extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { conversations, loggedUser } = this.props;

        if( conversations.selected.id ) {
            const selected = conversations.selected;
            const creator = selected.creator;
            const isArchived = selected.tagged_users.filter( u => !u.isRemoved ).length < 2;
            const users    = [...selected.tagged_users.filter( u => u.user.id === creator.id ), ...conversations.selected.tagged_users.filter( u => u.user.id !== creator.id )];
            const isAdminNotMember = loggedUser.data.userRole < 3 && conversations.selected.tagged_users.filter( u => u.linkId === loggedUser.data.id ).length === 0;
            const isMember = conversations.selected.tagged_users.filter(t=>t.linkId === loggedUser.data.id);
            let actionButton;

            const onDeleteUser = ( u ) => {
                if( !isArchived ) {
                    if( loggedUser.data.id === u.user.id ) {
                        this.props.onRemoveMemberModal( u.user.id, "me" );
                    } else {
                        this.props.onRemoveMemberModal( u.user.id, "other" );
                    }
                } else {
                    this.props.onRemoveMemberModal( u.user.id, "archived" );
                }

                $( "#removeMember" ).modal( "show" );
            }

            const handleDisplayButtons = ( u ) => {
                if (this.props.isAdmin) {
                    if (!isAdminNotMember) {
                        if (!u.isRemoved && !isArchived && u.user.id !== loggedUser.data.id) {
                            actionButton = <button type="button" class={`btn btnRemove`} onClick={ () => onDeleteUser( u ) }>Remove</button>
                        }
                    }
                    if (!u.isRemoved) {
                        if (!isArchived && u.user.id === loggedUser.data.id ) {
                            actionButton = <button type="button" class={`btn btnRemove`} onClick={ () => onDeleteUser( u ) }>Leave</button>
                        }
                        else if (isArchived) {
                            actionButton = <button type="button" class={`btn btnRemove`} onClick={ () => onDeleteUser( u ) }>Archive</button>
                        }
                    }
                    else {
                        if (u.isArchived) {
                            actionButton = <button type="button" class={`btn btnRemove disabled`}>Archived</button>
                        } 
                        else if (u.user.id !== loggedUser.data.id && !u.isArchived) {
                            actionButton = <button type="button" class={`btn btnRemove disabled`}>Removed</button>
                        }
                        else if (u.user.id === loggedUser.data.id && !u.isArchived) {
                            actionButton = <button type="button" class={`btn btnRemove disabled`}>Left</button>
                        }
                    }
                }

                return actionButton;
            }
            
            return (
                users.map( u => ( 
                    <div class={`memberItem ${ u.isRemoved ? "removed" : ""}`}>
                        <div class="memberDetails">
                                <div class="memberAvatar">
                                    <Avatar name={`${ u.user.firstName } ${ u.user.lastName }`} disableTooltip={true} image={u.user.avatar !== "default.png" ? `/api/file/profile_pictures/${u.user.avatar}` : null} />
                                </div>
                                <div class="memberContent">
                                    <p>
                                        {`${ u.user.firstName } ${ u.user.lastName }`} 
                                        { u.user.id === creator.id && <span> (Creator)</span> }
                                    </p>
                                </div>
                            </div>
                    
                        <div class={`memberActions ${ !this.props.isAdmin || selected.isArchived || isMember.length <= 0 ? "externalUser" : ""}`}>
                            <div class="memberRole">
                                <p>{
                                    u.user.user_role && u.user.user_role.length > 0
                                        ? `${u.user.user_role[0].role.roleType} ${u.user.user_role[0].role.role}`
                                        : "No Role"
                                }</p>
                            </div>
                            { !selected.isArchived && isMember.length > 0 && (
                                <div> {handleDisplayButtons(u)} </div>
                            )}
                        </div>
                    </div>
                ))
            );
        }

        return null;
    }
}

export default Member;
